import DeviceEntityContent from '@/components/entity-detail/components/Entity/DeviceEntity';
import type { TDetailServiceParams } from '@/components/entity-detail/types/EntityType.types';
import { DEVICE_PARAMS } from '@/constants/query-params/device.constant';
import { deviceService } from '@/services/rest';
import type { DeviceResponse } from '@/types/apps/device.type';
import type { ApiResponse } from '@/types/common/api.type';
import { t } from '@/utils/lang';
import { Entity } from '../entity';

export class DeviceEntity extends Entity {
    public getTitleTemplate(response?: string): string {
        if (!response) {
            return t('Thiết bị');
        }

        return `${t('Thiết bị')}: ${this.getTitle(response)}`;
    }

    public getEntityComponent(): any {
        return DeviceEntityContent;
    }

    public getIncludeProperties() {
        return DEVICE_PARAMS;
    }

    public getDetailService(
        params: TDetailServiceParams
    ): Promise<ApiResponse<DeviceResponse>> {
        return deviceService().detail(params.id, {
            ...this.getIncludeProperties(),
            ...params,
        });
    }

    public getFieldName(): string {
        return 'name';
    }

    public getDetailUrl(id: string): string {
        return this.routeManager.getRouteMap()[this.getRouteDetail()].path(id);
    }

    public showDetailButton(): boolean {
        return true;
    }

    public getRouteDetail(): string {
        return this.routeManager.DEVICE_DETAIL;
    }
}
